import { BookWidgetAem } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { createAction, props } from '@ngrx/store';

enum AemActionTypes {
  loadBookWidgetAem = '[flight-shop book widget] load book widget aem',
  loadBookWidgetAemSuccess = '[flight-shop book widget] load book widget aem success',
  loadBookWidgetAemFailure = '[flight-shop book widget] load book widget aem failure'
}

export const LoadBookWidgetAem = createAction(AemActionTypes.loadBookWidgetAem);

export const LoadBookWidgetAemSuccess = createAction(
  AemActionTypes.loadBookWidgetAemSuccess,
  props<{ bookWidgetAem: BookWidgetAem }>()
);

export const LoadBookWidgetAemFailure = createAction(
  AemActionTypes.loadBookWidgetAemFailure
);
